import api from '../api/auth';

const ManagerLoginService = ({ userId, password }) => {
  return api.post('/login', { userId, password });
};

export { ManagerLoginService };
